import * as _ from 'lodash-es';
import { Entity } from 'breeze-client';
import {
    ValidatorBase,
    ValidatorMetadata,
    ValidationContextBase,
    ValidationContext,
    VALIDATOR_FACTORY,
    ValidationError,
    Validator,
} from '.';
import { ValueProvider } from '@angular/core';

export class BreezeValidationAdapter
    extends ValidatorBase
    implements Validator
{
    metadata: ValidatorMetadata;
    readonly isAsync = false;

    constructor(
        group: string,
        validatorContext?: Partial<ValidationContextBase>
    ) {
        super('breeze', group, {
            ...validatorContext,
            messageTemplate: 'Breeze validation error', // Gets overwritten with the messageTemplate from Breeze
        });
    }

    static create(
        group: string,
        context?: Partial<ValidationContextBase>
    ): BreezeValidationAdapter {
        return new BreezeValidationAdapter(group, context);
    }

    validate(
        value: any,
        context?: ValidationContext
    ): ValidationError | ValidationError[] | null {
        const entity = value as Entity;
        if (!entity.entityAspect) {
            return null;
        }

        if (entity.entityAspect.validateEntity()) {
            return null;
        }

        const ctx = this.getValidatorFunctionContext(value, context);

        const validationErrors = entity.entityAspect.getValidationErrors();
        return validationErrors.map((validationError) => {
            const validatorCtx = { ...validationError.validator.context };
            // Remove all properties that start with $
            Object.keys(validatorCtx)
                .filter((key) => key.startsWith('$'))
                .forEach((key) => delete validatorCtx[key]);

            const propertyMetadata =
                validationError.property &&
                ctx.metadata &&
                ctx.metadata.properties.find(
                    (pm) => pm.propertyName === validationError.propertyName
                );

            const errorCtx = {
                ...validationError.context,
                ...ctx,
                ...validatorCtx,
                displayName:
                    (propertyMetadata && propertyMetadata.displayName) ||
                    (validationError.property &&
                        validationError.property.displayName),
                value: validationError.propertyName
                    ? _.get(ctx.value, validationError.propertyName)
                    : ctx.value,
            };
            return new ValidationError(validationError.key, errorCtx, this);
        });
    }
}

export const breezeValidationAdapaterProvider: ValueProvider = {
    provide: VALIDATOR_FACTORY,
    useValue: {
        name: 'breeze',
        fn: BreezeValidationAdapter.create,
    },
    multi: true,
};
